import BigNumber from 'bignumber.js'
import { BIG_ZERO } from 'utils/bigNumber'
import { deserializeToken } from 'state/user/hooks/helpers'
import { SerializedFarm, DeserializedFarmUserData, DeserializedFarm } from 'state/types'

const LP_SYMBOL_REGEX = / LP$/

const deserializeFarm = (farm: SerializedFarm): DeserializedFarm => {
  const {
    lpAddresses,
    lpSymbol,
    pid,
    dual,
    multiplier,
    isCommunity,
    quoteTokenPriceUsdc,
    tokenPriceUsdc,
    version,
    rewarders,
    rewardData,
    enableBoost,
    ecoFarm,
    boostFarmExpired,
    loaded,
  } = farm

  const lpTokenBalanceMC = farm.lpTokenBalanceMC ? new BigNumber(farm.lpTokenBalanceMC) : BIG_ZERO
  const lpTokenAmountInCraftsmanV2 = farm.lpTokenAmountInCraftsmanV2
    ? new BigNumber(farm.lpTokenAmountInCraftsmanV2)
    : BIG_ZERO

  return {
    lpAddresses,
    lpSymbol,
    lpSymbolLabel: lpSymbol.replace(LP_SYMBOL_REGEX, ''),
    pid,
    dual,
    multiplier,
    isCommunity,
    quoteTokenPriceUsdc,
    tokenPriceUsdc,
    token: deserializeToken(farm.token),
    quoteToken: deserializeToken(farm.quoteToken),
    userData: deserializeFarmUserData(farm),
    tokenAmountTotal: farm.tokenAmountTotal ? new BigNumber(farm.tokenAmountTotal) : BIG_ZERO,
    lpTotalInQuoteToken: farm.lpTotalInQuoteToken ? new BigNumber(farm.lpTotalInQuoteToken) : BIG_ZERO,
    lpTotalSupply: farm.lpTotalSupply ? new BigNumber(farm.lpTotalSupply) : BIG_ZERO,
    tokenPriceVsQuote: farm.tokenPriceVsQuote ? new BigNumber(farm.tokenPriceVsQuote) : BIG_ZERO,
    allocPoint: farm.allocPoint ? new BigNumber(farm.allocPoint) : BIG_ZERO,
    poolWeight: farm.poolWeight ? new BigNumber(farm.poolWeight) : BIG_ZERO,
    lpTokenBalanceMC,
    lpTokenAmountInCraftsmanV2,
    lpTotalStaked: farm.version === 2 ? lpTokenAmountInCraftsmanV2 : lpTokenBalanceMC,
    isFinished: farm.isFinished || false,
    migration: farm.migration || false,
    startFrom: farm.startFrom || '2000-01-01T00:00:00+00:00',
    version,
    suffix: farm.suffix || null,
    multiYieldLabel: farm.multiYieldLabel || false,
    rewarders,
    rewardData,
    enableBoost: enableBoost || false,
    boostFarmExpired,
    ecoFarm,
    loaded,
  }
}

export const EMPTY_DESERIALIZED_FARM_USER_DATA: DeserializedFarmUserData = {
  allowance: BIG_ZERO,
  tokenBalance: BIG_ZERO,
  stakedBalance: BIG_ZERO,
  earnings: BIG_ZERO,
  boostRewards: BIG_ZERO,
  boostRewardsAllFarms: BIG_ZERO,
  loaded: false,
}

const deserializeFarmUserData = (farm: SerializedFarm): DeserializedFarmUserData => {
  if (!farm.userData) return EMPTY_DESERIALIZED_FARM_USER_DATA

  return {
    allowance: new BigNumber(farm.userData.allowance),
    tokenBalance: new BigNumber(farm.userData.tokenBalance),
    stakedBalance: new BigNumber(farm.userData.stakedBalance),
    earnings: new BigNumber(farm.userData.earnings),
    boostRewards: new BigNumber(farm.userData.boostRewards),
    boostRewardsAllFarms: new BigNumber(farm.userData.boostRewardsAllFarms),

    ...(farm.userData.earningsV2
      ? {
          earningsV2: farm.userData.earningsV2,
        }
      : {}),

    loaded: farm.userData.loaded,
  }
}

export default deserializeFarm
